var render, staticRenderFns
import script from "./notificationPushSettingMixin.vue?vue&type=script&lang=js"
export * from "./notificationPushSettingMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2909b0c')) {
      api.createRecord('b2909b0c', component.options)
    } else {
      api.reload('b2909b0c', component.options)
    }
    
  }
}
component.options.__file = "src/components/modal/notificationPushSetting/mixin/notificationPushSettingMixin.vue"
export default component.exports